<template>
     <el-form ref="form" label-position="top">
         <el-form-item class="el-form-item-full"> <!-- Does not update yet -->
            <gmap-map
            v-bind:center="location"
            :zoom="12"
            map-type-id="terrain"
            style="width: 100% ; height: 250px"
            >
                <gmap-marker
                    :key="index"
                    v-for="(m, index) in markers"
                    :position="m.position"
                    :clickable="true"
                    :draggable="getSettingsGeographicalPosition.present == 0"
                    @dragend="changePos"
                    
                ></gmap-marker>
            </gmap-map>
        </el-form-item>
        <el-row :gutter="25">
            <el-col :lg="12">
                <el-form-item class="el-form-item-full" :label="$l('settings/geographicPosition/Latitude')">
                    <el-input :disabled="getSettingsGeographicalPosition.present == 1" v-model="getSettingsGeographicalPosition.lat"></el-input>
                </el-form-item>
            </el-col>
            <el-col :lg="12">
                <el-form-item class="el-form-item-full" :label="$l('settings/geographicPosition/Longitude')">
                    <el-input :disabled="getSettingsGeographicalPosition.present == 1" v-model="getSettingsGeographicalPosition.lon"></el-input>
                </el-form-item>
            </el-col>
            <el-col :lg="12">
                <el-form-item class="el-form-item-full" :label="$l('settings/geographicPosition/Height')">
                    <el-input :disabled="getSettingsGeographicalPosition.present == 1" v-model="getSettingsGeographicalPosition.height"></el-input>
                </el-form-item>
            </el-col>
        </el-row>
     </el-form>
    

</template>

<style>

</style>

<script>
import Vue from 'vue'
import {mapGetters} from 'vuex'
const VueGoogleMaps = require('vue2-google-maps');

Vue.use(VueGoogleMaps,{
    load:{
        key:'AIzaSyD5orU1Ahsfs8wZ-RwDIEf5cL-23ij44bc',
        v:'3',
    }
})

export default {
    data() {
        return {
            markers:[
            ]
        }
    },
    methods:{
        changePos(pos){
            this.getSettingsGeographicalPosition.lat = pos.latLng.lat();
            this.getSettingsGeographicalPosition.lon = pos.latLng.lng();
        },
    },
    computed:{
        ...mapGetters([
            'getSettingsGeographicalPosition',
        ]),
        location: function(){
            var location = {lat:0, lng:0};
            if(this.getSettingsGeographicalPosition.lat){
                location.lat = parseFloat(this.getSettingsGeographicalPosition.lat);
                location.lng = parseFloat(this.getSettingsGeographicalPosition.lon);
            }
            this.markers = [{position:{lat: location.lat, lng: location.lng}}];
            return location;
        }
    },
}
</script>


// WEBPACK FOOTER //
// GeoPos.vue?793fdd22